import {
  setUser,
  setLoading,
  setError,
  setMessage,
  getDashboardLoading,
  getDashboardSuccess,
  getDashboardFail,
  setUserTokenLoading,
  setUserTokenSuccess,
  setUserTokenFail,
} from "../../reducers/Authentication";

export const signUp = (user) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setUser(user));
    dispatch(setMessage("Success, user signed up!"));
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(setError(error.message));
    console.error("Error signing up:", error);
  }
};

export const login = (user) => async (dispatch) => {
  try {
    dispatch(setLoading());
    dispatch(setUser(user));
    dispatch(setMessage("Success, user logged in!"));
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(setError(error.response.data.message));
    console.error("Error logging in:", error);
  }
};

export const getDashboard = (db) => async (dispatch) => {
  try {
    dispatch(getDashboardLoading());
    dispatch(getDashboardSuccess(db));
  } catch (error) {
    dispatch(getDashboardLoading());
    dispatch(getDashboardFail(error.response.data.message));
    console.error(error);
  }
};
export const setUserToken = (token) => async (dispatch) => {
  try {
    dispatch(setUserTokenLoading());
    dispatch(setUserTokenSuccess(token));
  } catch (error) {
    dispatch(setUserTokenFail("Failed to set user token!"));
    console.error(error);
  }
};
